@if (consent.bannerVisible()) {
  <section
    role="region"
    aria-label="Gestion des cookies"
    class="fixed inset-x-0 bottom-0 z-50 border-t-2 border-primary bg-white p-4 shadow-[0_-4px_16px_rgba(0,0,0,0.15)]">
    <div class="mx-auto flex max-w-5xl flex-col gap-4 font-raleway text-gray-900 md:flex-row md:items-center">
      <div class="flex-1 text-sm">
        <p class="mb-1 text-base font-bold">Votre vie privée</p>
        <p>
          Ce site fonctionne sans traceur publicitaire ni mesure d'audience. Certains contenus (carte Google Maps,
          vidéos YouTube) déposent toutefois des cookies : ils ne sont chargés que si vous les acceptez.
          Vous pouvez changer d'avis à tout moment via « Gérer mes cookies » en bas de page.
          <a href="/cookies" class="font-semibold text-primary underline">Politique de cookies</a>
        </p>
      </div>
      <div class="flex flex-col gap-2 sm:flex-row sm:flex-wrap md:flex-nowrap">
        <button type="button" [class]="buttonClass" (click)="consent.refuseAll()">Tout refuser</button>
        <button type="button" [class]="buttonClass" (click)="consent.acceptAll()">Tout accepter</button>
        <button type="button" [class]="buttonClass" (click)="consent.openPreferences()">Personnaliser</button>
      </div>
    </div>
  </section>
}

@if (consent.preferencesOpen()) {
  <div class="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4" (click)="consent.closePreferences()">
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-dialog-title"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      (keydown.escape)="onEscape()"
      (click)="$event.stopPropagation()"
      class="max-h-[90vh] w-full max-w-2xl overflow-y-auto rounded-lg bg-white p-6 font-raleway text-gray-900 shadow-xl">
      <h2 id="cookie-dialog-title" class="mb-2 text-2xl font-bold font-alice">Gérer mes cookies</h2>
      <p class="mb-4 text-sm">
        Choisissez les contenus tiers que vous autorisez. Rien n'est chargé sans votre accord.
        Votre choix est conservé 6 mois, puis nous vous le redemanderons.
      </p>

      <ul class="mb-4 divide-y divide-gray-200 rounded-md border border-gray-300">
        <li class="flex items-start justify-between gap-4 p-4">
          <div class="text-sm">
            <p class="font-bold">Cookies strictement nécessaires</p>
            <p>
              Connexion à l'espace membres et mémorisation de votre choix sur les cookies. Ils ne peuvent pas être
              désactivés et ne nécessitent pas votre accord.
            </p>
          </div>
          <span class="whitespace-nowrap rounded-full bg-gray-200 px-3 py-1 text-xs font-semibold">Toujours actifs</span>
        </li>
        <li class="flex items-start justify-between gap-4 p-4">
          <div class="text-sm">
            <label for="consent-maps" class="font-bold">Carte Google Maps</label>
            <p>
              Affiche la carte de notre salle de répétition. Fournie par Google, qui peut déposer des cookies et
              traiter votre adresse IP, y compris hors de l'Union européenne.
            </p>
          </div>
          <input id="consent-maps" type="checkbox" class="mt-1 h-6 w-6 shrink-0 accent-primary"
            [checked]="consent.draft().maps" (change)="consent.setDraft('maps', $any($event.target).checked)">
        </li>
        <li class="flex items-start justify-between gap-4 p-4">
          <div class="text-sm">
            <label for="consent-youtube" class="font-bold">Vidéos YouTube</label>
            <p>
              Affiche les vidéos intégrées au site. Fournies par YouTube (Google), qui peut déposer des cookies et
              traiter votre adresse IP, y compris hors de l'Union européenne.
            </p>
          </div>
          <input id="consent-youtube" type="checkbox" class="mt-1 h-6 w-6 shrink-0 accent-primary"
            [checked]="consent.draft().youtube" (change)="consent.setDraft('youtube', $any($event.target).checked)">
        </li>
      </ul>

      <div class="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <button type="button" [class]="buttonClass" (click)="consent.refuseAll()">Tout refuser</button>
        <button type="button" [class]="buttonClass" (click)="consent.acceptAll()">Tout accepter</button>
        <button type="button" [class]="buttonClass" (click)="consent.saveDraft()">Enregistrer mes choix</button>
      </div>
      <p class="mt-4 text-xs">
        <a href="/cookies" class="text-primary underline">Voir le détail dans la politique de cookies</a>
        ·
        <button type="button" class="underline" (click)="consent.closePreferences()">Fermer</button>
      </p>
    </div>
  </div>
}
